// * =================================================================================================================
// *                                              User Routes
// * =================================================================================================================
// GET
export const FIND_USER = "/new-user/user/find";
export const FIND_USER_v2 = "/find";
// GET
export const IS_USER_AND_TYPE_EXIST = "/new-user/archivist/is-user-exist";
// GET
export const GET_USER_INFO = "/new-user/user/find-me";
// POST
export const SEND_VERIFICATION_SMS = "/new-user/user/send-verify-code";
// POST
export const VERIFY_CODE = "/new-user/user/verify-code";

export const VERIFY_CODE_DRIVER = "/new-user/user/verify-code-driver";
// POST
export const CREATE_ADMIN = "/new-user/administrator/admin/create";
// POST
export const block_USER = "/new-user/block/manager";
// DEL
export const UN_BLOCK = "/new-user/block/unblock-by-block-id";
// PUT
export const UPDATE_ADMIN = "/new-user/administrator/admin/create";
// PUT
export const SUB_LOGIN = "/new-user/user/sub-login";

// * =================================================================================================================
// *                                              User Routes
// * =================================================================================================================
// GET
export const ADMIN_DEBT_FACTORS = "/financial/withdrawal/find-by-userId";
// GET
export const PAY_ADMIN_DEBT_FACTORS = "/financial/withdrawal/pay-by-userId";

// * =================================================================================================================
// *                                            SuperAgent Routes
// * =================================================================================================================
// POST
export const CREATE_SUPER_AGENT = "/new-user/administrator/super-agent-school";
// PUT
export const UPDATE_SUPER_AGENT = "/new-user/administrator/super-agent-school";
// DELETE
export const DELETE_SUPER_AGENT = "/new-user/administrator/super-agent-school";
// POST
export const CREATE_SUPER_AGENT_PROVINCE =
  "/new-user/administrator/province-education";
// PUT
export const UPDATE_SUPER_AGENT_PROVINCE =
  "/new-user/administrator/province-education";

// * =================================================================================================================
// *                                            Government Ship Routes
// * =================================================================================================================
// POST
export const CREATE_GOVERNMENT_SHIP = "/new-user/administrator/government-ship";
// PUT
export const UPDATE_GOVERNMENT_SHIP = "/new-user/administrator/government-ship";
// * =================================================================================================================
// *                                          City & Province Routes
// * =================================================================================================================
// GET
export const GET_ALL_PROVINCE = "/new-user/province/school/get-all-province";
// GET
export const GET_ALL_CITY = "/new-user/province/school/get-all-city-province";
// * =================================================================================================================
// *                                               Company Routes
// * =================================================================================================================
// POST
export const CREATE_COMPANY = "/new-user/administrator/company";
// POST
export const CREATE_COMPANY_PUBLIC = "/new-user/company/public";
// POST
export const FIND_COMPANY = "/new-user/user/find-v2";
// POST
export const APPROVE_COMPANY = "/new-user/company/approve";
// POST
export const APPROVE_COMPANY_DOCUMENTS = "/new-user/upload/company/approve";
// POST
export const UPLOAD_DOCUMENT_COMPANY = "/new-user/upload/company/doc";
// POST
// export const PAY_OFFLINE = "/financial/financial/pay-service-from-wallet";
export const PAY_OFFLINE = "/financial/financial/pay-offline-parent";
// POST
export const PAY_DEBT_TO_DRIVER = "/financial/debt/pay-by-company";
// POST
export const FIND_COMPANY_FACTOR = "/financial/factor/find-by-company-id";
// POST
export const PRICE_TO_PAY_DRIVER = "/financial/financial/get-driver-factors";
export const PRICE_TO_PAY_DRIVER_FOR_ADMIN =
  "/financial/financial/admin/get-driver-factors";
// POST
export const PAY_DRIVER_DEBT_BY_CHECK_MARK =
  "/financial/financial/pay-driver-factors";
// POST
export const PAY_ALL_DRIVER_FACTORS =
  "/financial/factor/pay-all-driver-factors";
// POST
export const FIND_COMPANY_DEBT_TO_DRIVER =
  "/financial/debt/find-price-company-to-driver";
// PUT
export const UPDATE_COMPANY = "/new-user/administrator/company";
// DELETE
export const DELETE_COMPANY = "/new-user/administrator/company";
// * =================================================================================================================
// *                                               School Routes
// * =================================================================================================================
// GET
export const GET_ALL_SCHOOL = "/school/school/find";
// POST
export const CREATE_SCHOOL_COMPANY = "/school/school/company";
// POST
export const FIND_SCHOOL = "/school/school/find-Dashboard";
// POST
export const CREATE_SCHOOL_PARENT = "/school/school/parent";
// PUT
export const UPDATE_SCHOOL = "/school/school";
// PUT
export const APPROVE_SCHOOL = "/school/school/approve";
// PUT
export const REJECT_SCHOOL = "/school/school/reject";
// DELETE
export const DELETE_SCHOOL = "/school/school";
// * =================================================================================================================
// *                                               Driver Routes
// * =================================================================================================================
// GET
export const GET_ALL_DRIVER_FACTOR = "/financial/factor/get-all-driver-factors";
// POST
export const CREATE_DRIVER = "/new-user/company/driver";
// POST
export const FIND_DRIVER = "/new-user/user/find-v2";
export const FIND_DRIVER_CLOSED_FACTOR = "/financial/financial-report/driver";
// PUT
export const UPDATE_DRIVER = "/new-user/company/driver";
// PUT
export const APPROVE_DRIVER = "/new-user/company/driver/approve";
// PUT
export const UPDATE_DRIVER_DEPOSIT = "/new-user/company/driver/deposit";
// PUT
export const APPROVE_DRIVER_DOCUMENTS = "/new-user/upload/driver/approve";
// PUT
export const DRIVER_UPDATE_SERVICE = "/school/service/update-service-4-company";
// PUT
export const ADD_SERVICE_TO_DRIVER = "/school/service/attach-driver-2-service";
// POST
export const TRANSFER_DRIVERS_ACADEMIC_YEAR = "/new-user/user/transfer-drivers-academic-year";
// DELETE
export const DELETE_DRIVER = "/new-user/company/driver";
// * =================================================================================================================
// *                                               Parent Routes
// * =================================================================================================================
// POST

export const CREATE_PARENT = "/new-user/company/parent";
export const FIND_PARENT = "/new-user/user/find-v2";
// PUT
export const UPDATE_PARENT = "/new-user/company/parent";
// DELETE
export const DELETE_PARENT = "/new-user/company/parent";
// DELETE
export const DELETE_SERVICE_FROM_DRIVER = "/school/service/delete-driver";
// * =================================================================================================================
// *                                               Service Routes
// * =================================================================================================================
// GET
export const ADMIN_ALL_SERVICE = "/school/service/admin-all-Service";
// POST
export const FIND_SERVICE = "/school/service/find";
// PUT
export const APPROVE_SERVICE = "/school/service/approve";
// PUT
export const UPDATE_SERVICE = "/school/service";
// * =================================================================================================================
// *                                              Storage Routes
// * =================================================================================================================
// GET
export const GET_FILE = "/new-user/upload";
// POST
export const UPLOAD_FILE = "/new-user/upload";
// * =================================================================================================================
// *                                              Student Routes
// * =================================================================================================================
// GET
export const FIND_STUDENT = "/school/student/find";
// POST
export const CREATE_STUDENT = "/school/student";
// PUT
export const UPDATE_STUDENT = "/school/student";

// * =================================================================================================================
// *                                              Student Routes
// * =================================================================================================================

// POST
export const FIND_ABSENT = "/school/service/find-absent";
// PUT
export const UPDATE_ABSENT = "/school/service/absent";

// * =================================================================================================================
// *                                              Student Routes
// * =================================================================================================================

// POST
export const FIND_LOG = "/school/service/find-log";

// * =================================================================================================================
// *                                              financial group
// * =================================================================================================================

// POST
export const FIND_FINANCIAL_GROUP = "/financial/financial-group/find";
export const CREATE_FINANCIAL_GROUP = "financial/financial-group";
export const DELETE_FINANCIAL_GROUP = "financial/financial-group";
export const UPDATE_FINANCIAL_GROUP = "financial/financial-group";
export const FIND_DEBTS = "financial/withdrawal/find-need-pay";
// GET
export const GET_FINANCIAL_GROUP_BY_ID = "financial/financial-group";

// * =================================================================================================================
// *                                              financial pay
// * =================================================================================================================

// POST
export const GET_PAY_LINK = "financial/financial/pay-service";
export const FIND_TRANSACTION = "financial/transaction/find";
export const FIND_DRIVER_TRANSACTION = "financial/transaction/find-on-drivers";
export const FIND_TRANSACTION_REPORT = "financial/financial-report/find";
export const FIND_MICRO_TRANSACTION = "financial/transaction/find-child";
export const PAY_DEBT_BY_ADMIN = "financial/debt/pay-by-admin";
export const TOTAL_FACTOR_PRICE_FOR_DRIVER =
  "financial/financial/get-driver-factors";
export const TOTAL_FACTOR_PRICE_FOR_PARENT =
  "financial/financial/get-driver-factors-by-parent";
// PUT
export const PAY_DEBT_BY_ADMIN_PUT = "financial/withdrawal/pay-by-userId";

// GET
export const GET_INVOICES = "financial/financial/price-to-pay";

// * =================================================================================================================
// *                                              financial withdrawal
// * =================================================================================================================

// POST
export const WITHDRAWAL_REQUEST    = 'financial/withdrawal/request';
export const WITHDRAWAL_FIND       = 'financial/withdrawal/find';
export const WITHDRAWAL_APPROVE    = 'financial/withdrawal/accept';
export const WITHDRAWAL_DISAPPROVE = 'financial/withdrawal/reject';

export const ADMIN_WITHDRAWAL_FROM_ACCOUNT = 'financial/withdrawal/admin/withdrawal-from-account';

// * =================================================================================================================
// *                                              municipality
// * =================================================================================================================

export const MUNICYPULITY_CREATE = "new-user/administrator/municipality";
export const MUNICYPULITY_UPDATE = "new-user/administrator/municipality";

// * =================================================================================================================
// *                                              ticket
// * =================================================================================================================

export const FIND_TICKET = "new-user/ticket/find";
export const REPLY_TICKET = "new-user/ticket/reply";

export const GET_OR_EXIST_PARENT: "new-user/company/get-or-exist-parent" =
  "new-user/company/get-or-exist-parent";
export const CREAT_OR_UPDATE_PARENT: "new-user/company/create-or-update-parent" =
  "new-user/company/create-or-update-parent";

export const CREATE_OR_UPDATE_SERVICE: "school/service/create-or-update-fast-service" =
  "school/service/create-or-update-fast-service";
// * =================================================================================================================
// *                                              admin
// * =================================================================================================================
// POST
export const  FIND_APPROVE_PARENT_TRANSACTION= "financial/factor/need-2-check-by-admin";
export const  FIND_REJECTED_PARENT_TRANSACTION= "financial/factor/rejected-by-admin";
export const FIND_PAY_ADMIN_TO_DRIVER = "financial/withdrawal/find";
// PUT
export const ACCEPT_MANY_PAY_TO_DRIVER = "financial/withdrawal/accept-many";
export const REJECT_MANY_PAY_TO_DRIVER = "financial/withdrawal/reject-many";
export const SEND_TO_BANK_MANY_PAY_TO_DRIVER = "financial/withdrawal/send-2-bank-many";
export const UPDATE_PRICE_FACTOR_4_ADMIN = 'financial/factor/update-price-4-admin'

export const ACCEPT_PAY_TO_DRIVER = "financial/withdrawal/accept";
export const REJECT_PAY_TO_DRIVER = "financial/withdrawal/reject-many";
export const SEND_TO_BANK_PAY_TO_DRIVER =
  "financial/withdrawal/send-2-bank-many";
// GET
export const APPROVE_PARENT_TRANSACTION = "financial/factor/accept-factor-admin";
export const DISAPPROVE_PARENT_TRANSACTION = "financial/factor/reject-factor-admin";

export const UPDATE_COMPANY_2_IS_FAVORITE = "new-user/company/add-2-favorite";
export const UPDATE_COMPANY_2_NOT_FAVORITE = "new-user/company/remove-favorite";

export const ADMIN_GET_COMPANY_DEPOSITE = 'financial/financial-report-company/admin-get-price'
export const ADMIN_PAY_COMPANY_DEPOSITE = 'financial/financial-report-company/admin-pay-price'

// * Company withdrawals -----------------------------------------------------------------------------------------------
// POST
export const ADMIN_FIND_WITHDRAWAL_COMPANIES = 'financial/withdrawal-company/find';
// PUT
export const ADMIN_SEND_2_BANK_MANY_WITHDRAWAL_COMPANIES = 'financial/withdrawal-company/send-2-bank-many';
export const ADMIN_REJECT_MANY_WITHDRAWAL_COMPANIES      = 'financial/withdrawal-company/reject-many';
export const ADMIN_ACCEPT_MANY_WITHDRAWAL_COMPANIES      = 'financial/withdrawal-company/accept-many';
export const ADMIN_SEND_2_BANK_WITHDRAWAL_COMPANIES      = 'financial/withdrawal-company/send_2_bank';
export const ADMIN_REJECT_WITHDRAWAL_COMPANIES           = 'financial/withdrawal-company/reject';
export const ADMIN_ACCEPT_WITHDRAWAL_COMPANIES           = 'financial/withdrawal-company/accept';

// * Company financial -------------------------------------------------------------------------------------------------
// GET
export const COMPANY_GET_FACTORS_IS_NEED_PAY_2_COMPANY   = 'financial/factor/comapny/get-creditor-invoices';
export const COMPANY_PAY_FACTORS_IS_NEED_PAY_2_COMPANY   = 'financial/factor/comapny/pay-creditor-invoices';
export const COMPANY_PRICE_FACTORS_IS_NEED_PAY_2_COMPANY = 'financial/factor/comapny/price-creditor-invoices';

export const COMPANY_GET_COMPANY_DEPOSITE = 'financial/financial-report-company/company-get-price';
export const COMPANY_PAY_COMPANY_DEPOSITE = 'financial/financial-report-company/company-pay-price';

export const ADMIN_GET_PRIMARY_WALLET = 'financial/financial/get-primary-wallet';

// * Withdrawals routes ------------------------------------------------------------------------------------------------
// PUT
export const ACCEPT_WITHDRAWAL       = 'financial/withdrawal/accept';
export const REJECT_WITHDRAWAL       = 'financial/withdrawal/reject';
export const SEND_2_BANK_WITHDRAWALS = 'financial/withdrawal/send_2_bank';

export const ACCEPT_MANY_WITHDRAWALS      = 'financial/withdrawal/accept-many';
export const REJECT_MANY_WITHDRAWALS      = 'financial/withdrawal/reject-many';
export const SEND_2_BANK_MANY_WITHDRAWALS = 'financial/withdrawal/send-2-bank-many';

// * Location routes ---------------------------------------------------------------------------------------------------
export const LOCATION_CITY         = 'new-user/location/city'        ;
export const LOCATION_AREA         = 'new-user/location/town'        ;
export const LOCATION_PROVINCE     = 'new-user/location/province'    ;
export const LOCATION_NEIGHBORHOOD = 'new-user/location/neighborhood';

// * Factors witch one had online payment and company have own financial bank account ----------------------------------
// GET
export const ADMIN_GET_PAYEMNT_ONLINE_2_COMPANY = 'financial/factor/admin/get-is-need-pay-2-company';
export const ADMIN_PAY_PAYEMNT_ONLINE_2_COMPANY = 'financial/factor/admin/pay-is-need-pay-2-company';

export const REMOVE_IS_APPROVE_PARENT: '/new-user/user/parent-remove-archive' = '/new-user/user/parent-remove-archive';
export const REMOVE_IS_APPROVE_DRIVER: '/new-user/user/driver-remove-archive' = '/new-user/user/driver-remove-archive';

export const COMPANY_REMOVE_DRIVER_FROM_SERVICE: '/school/service/remove-driver' = '/school/service/remove-driver';
export const COMPANY_APPROVE_DRIVER_FOR_SERVICE: '/school/service/final-approve' = '/school/service/final-approve';

// * =================================================================================================================
// *                                          Academic Year Routes
// * =================================================================================================================
// GET
export const GET_ACADEMIC_YEARS = "/school/academic-year";
// POST / PATCH /:id / DELETE /:id — ADMIN only
export const ACADEMIC_YEAR = "/school/academic-year";
